'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { pick } from 'underscore';
import { FilePropTypes, FolderPropTypes } from 'DesignData/propTypes/finder';
import { RAW_ASSET } from 'DesignData/enums/FolderAssetTypes';
import makeAsyncModal from 'DesignComponents/modals/makeAsyncModal';
import * as finderSelectors from 'DesignData/selectors/finder';
import * as DesignAssetCategories from 'DesignData/enums/DesignAssetCategories';
import RawAssetModals from './RawAssetModals';
import { MODAL_TYPES } from 'DesignData/enums/FinderActionModalTypes';
import { byId } from 'ContentUtils/constants/TemplateTypes';
import { getActiveLayoutId } from 'DesignData/selectors/app';
import { closeActionModal } from 'DesignData/actions/finder/Modals';
const TemplateTypes = byId;
const PortalCopyModal = makeAsyncModal(() => import(
/* webpackChunkName: "modals" */
'DesignFinderUI/components/modals/PortalCopyModal'));
const CreateContentModal = makeAsyncModal(() => import(
/* webpackChunkName: "modals" */
'DesignFinderUI/components/modals/content/CreateContentModal'));
const DeleteFileModal = makeAsyncModal(() => import(
/* webpackChunkName: "modals" */
'DesignFinderUI/components/modals/DeleteFileModal'));
const MoveAssetsModal = makeAsyncModal(() => import(
/* webpackChunkName: "modals" */
'DesignFinderUI/components/modals/MoveAssetsModal'));
const BulkDeleteModal = makeAsyncModal(() => import(
/* webpackChunkName: "modals" */
'DesignFinderUI/components/modals/BulkDeleteModal'));
const DeleteFolderModal = makeAsyncModal(() => import(
/* webpackChunkName: "modals" */
'DesignFinderUI/components/modals/DeleteFolderModal'));
const NewThemeWizard = makeAsyncModal(() => import(
/* webpackChunkName: "modals" */
'DesignComponents/modals/NewThemeWizard'));
const NewChildThemeWizard = makeAsyncModal(() => import(
/* webpackChunkName: "modals" */
'DesignComponents/modals/NewChildThemeWizard'));
const ChildThemeAddModal = makeAsyncModal(() => import(
/* webpackChunkName: "modals" */
'DesignComponents/modals/ChildThemeAddModal'));
const FileInfoModal = makeAsyncModal(() => import(
/* webpackChunkName: "modals" */
'DesignFinderUI/components/modals/FileInfoModal'));
const PlanDowngradeModal = makeAsyncModal(() => import(
/* webpackChunkName: "modals" */
'DesignManagerIde/components/modals/PlanDowngradeModal'));

class ActionModals extends Component {
  constructor(...args) {
    super(...args);

    this.handleModalCallback = () => {
      this.props.closeActionModal();
    };
  }

  renderCreateContentWizard() {
    const {
      fileId,
      fileType,
      fileTemplateType,
      file
    } = this.props;
    const {
      path,
      generatedTemplatePath
    } = file || {};
    const fileTemplatePath = generatedTemplatePath || path;
    const category = TemplateTypes[fileTemplateType].categoryId === DesignAssetCategories.EMAIL ? DesignAssetCategories.EMAIL : DesignAssetCategories.PAGE;
    return /*#__PURE__*/_jsx(CreateContentModal, {
      fileId: fileId,
      onReject: this.handleModalCallback,
      category: category,
      fileType: fileType,
      fileTemplateType: fileTemplateType,
      fileTemplatePath: fileTemplatePath
    }, "createContentWizard");
  }

  renderDeleteFolderModal() {
    const {
      folderId,
      parentFolderId
    } = this.props;
    return /*#__PURE__*/_jsx(DeleteFolderModal, {
      callback: this.handleModalCallback,
      folderId: folderId,
      parentFolderId: parentFolderId
    }, "DeleteFolderModal");
  }

  renderBulkDeleteModal() {
    return /*#__PURE__*/_jsx(BulkDeleteModal, {
      callback: this.handleModalCallback
    }, "bulk-delete-modal");
  }

  renderMoveAssetsModal() {
    const {
      fileId,
      fileType,
      folderId,
      fileName
    } = this.props;
    return /*#__PURE__*/_jsx(MoveAssetsModal, {
      callback: this.handleModalCallback,
      fileId: fileId,
      fileType: fileType,
      fileName: fileName,
      folderId: folderId
    }, "MoveAssetsModal");
  }

  renderDeleteModal() {
    const {
      fileId
    } = this.props;
    return /*#__PURE__*/_jsx(DeleteFileModal, {
      callback: this.handleModalCallback,
      fileId: fileId
    }, "DeleteFileModal");
  }

  renderPlanDowngradeModal() {
    return /*#__PURE__*/_jsx(PlanDowngradeModal, {
      callback: this.handleModalCallback
    }, "PlanDowngradeModal");
  }

  renderPortalCopyModal() {
    const {
      file,
      folder,
      activeThemeFolder
    } = this.props;
    const asset = file || activeThemeFolder || folder;
    return /*#__PURE__*/_jsx(PortalCopyModal, {
      callback: this.handleModalCallback,
      asset: asset
    }, "PortalCopyModal");
  }

  renderThemeDuplicateModal() {
    const {
      rootFolderId,
      folder,
      activeThemeFolder
    } = this.props;
    const folderToDuplicate = activeThemeFolder || folder;
    return /*#__PURE__*/_jsx(NewThemeWizard, {
      callback: this.handleModalCallback,
      folderId: rootFolderId,
      themeName: `${folderToDuplicate.label} copy`,
      baseThemeFolder: folderToDuplicate
    });
  }

  renderCreateChildThemeWizard() {
    const {
      rootFolderId,
      folder,
      activeThemeFolder
    } = this.props;
    const parentTheme = activeThemeFolder || folder;
    return /*#__PURE__*/_jsx(NewChildThemeWizard, {
      callback: this.handleModalCallback,
      folderId: rootFolderId,
      themeName: `${parentTheme.label} child`,
      baseThemeFolder: parentTheme
    });
  }

  renderChildThemeAddModal() {
    const {
      file,
      folder
    } = this.props;
    const asset = file || folder;
    return /*#__PURE__*/_jsx(ChildThemeAddModal, {
      callback: this.handleModalCallback,
      asset: asset
    }, "ChildThemeAddModal");
  }

  renderShowInformationModal() {
    if (!this.props.file) return null;
    const {
      id,
      path,
      created,
      updated,
      name,
      width,
      height,
      type: fileType,
      isReadOnly,
      templateType,
      moduleId,
      global,
      generatedTemplatePath,
      size
    } = this.props.file;
    return /*#__PURE__*/_jsx(FileInfoModal, {
      callback: this.handleModalCallback,
      updated: updated,
      created: created,
      path: path,
      name: name,
      width: width,
      height: height,
      id: id,
      fileType: fileType,
      isReadOnly: isReadOnly,
      templateType: templateType,
      moduleId: moduleId,
      global: global,
      size: size,
      generatedTemplatePath: generatedTemplatePath
    }, "FileInfoModal");
  }

  render() {
    switch (this.props.actionModal) {
      case MODAL_TYPES.DELETE:
        return this.renderDeleteModal();

      case MODAL_TYPES.PORTAL_COPY_WIZARD:
        return this.renderPortalCopyWizard();

      case MODAL_TYPES.BULK_DELETE:
        return this.renderBulkDeleteModal();

      case MODAL_TYPES.DELETE_FOLDER:
        return this.renderDeleteFolderModal();

      case MODAL_TYPES.BULK_PORTAL_COPY_WIZARD:
        return this.renderBulkPortalCopyWizard();

      case MODAL_TYPES.CREATE_CONTENT:
        return this.renderCreateContentWizard();

      case MODAL_TYPES.BULK_MOVE:
      case MODAL_TYPES.MOVE_ASSET:
        return this.renderMoveAssetsModal();

      case MODAL_TYPES.THEME_DUPLICATE:
        return this.renderThemeDuplicateModal();

      case MODAL_TYPES.CREATE_CHILD_THEME_WIZARD:
        return this.renderCreateChildThemeWizard();

      case MODAL_TYPES.CHILD_THEME_ADD_WIZARD:
        return this.renderChildThemeAddModal();

      case MODAL_TYPES.ASSET_PORTAL_COPY:
        return this.renderPortalCopyModal();

      case MODAL_TYPES.SHOW_INFORMATION:
        {
          if (this.props.fileType !== RAW_ASSET) {
            return this.renderShowInformationModal();
          }

          break;
        }

      case MODAL_TYPES.PLAN_DOWNGRADE:
        {
          return this.renderPlanDowngradeModal();
        }

      default:
    }

    if (this.props.fileType === RAW_ASSET) {
      return /*#__PURE__*/_jsx(RawAssetModals, {
        closeActionModal: this.props.closeActionModal,
        assetId: this.props.fileId,
        modal: this.props.actionModal
      });
    }

    return null;
  }

}

ActionModals.propTypes = {
  closeActionModal: PropTypes.func.isRequired,
  file: FilePropTypes.file,
  fileId: FilePropTypes.fileId,
  fileType: FilePropTypes.fileType,
  fileTemplateType: FilePropTypes.fileTemplateType,
  folderId: FolderPropTypes.folderId,
  fileName: FilePropTypes.fileName,
  parentFolderId: FolderPropTypes.folderId,
  actionModal: PropTypes.oneOf(Object.keys(MODAL_TYPES)),
  rootFolderId: FolderPropTypes.folderId,
  folder: FolderPropTypes.folder,
  activeThemeFolder: FolderPropTypes.folder
};
const mapDispatchToProps = {
  closeActionModal
};

function makeMapStateToProps() {
  const getFileProps = finderSelectors.makeGetFileProps();
  const getFolderProps = finderSelectors.makeGetFolderProps();
  const getActiveThemeFolder = finderSelectors.makeGetActiveThemeFolder();
  return function mapStateToProps(state, props) {
    const activeLayoutId = getActiveLayoutId(state, props);
    const fileProps = getFileProps(state, Object.assign({}, props, {
      layoutId: activeLayoutId
    }));
    const {
      folderId: __fileFolderId
    } = fileProps || {};
    const folderProps = getFolderProps(state, props);
    const actionModal = finderSelectors.getActionModal(state);
    return Object.assign({}, pick(fileProps, 'fileId', 'file', 'fileTemplateType', 'fileName', 'fileType', 'generatedTemplatePath'), {}, pick(folderProps, 'folderId', 'folderName', 'folder'), {
      folderId: __fileFolderId || props.folderId,
      actionModal,
      rootFolderId: finderSelectors.getRootFolderId(state, props),
      activeThemeFolder: getActiveThemeFolder(state)
    });
  };
}

export default connect(makeMapStateToProps, mapDispatchToProps)(ActionModals);